import { render, staticRenderFns } from "./ECommerceDataReport.vue?vue&type=template&id=be120a96&scoped=true&"
import script from "./ECommerceDataReport.vue?vue&type=script&lang=js&"
export * from "./ECommerceDataReport.vue?vue&type=script&lang=js&"
import style0 from "./ECommerceDataReport.vue?vue&type=style&index=0&id=be120a96&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be120a96",
  null
  
)

export default component.exports